import rawTemplates from "./lark-cli-verified-templates.json" with { type: "json" };
function isNonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0;
}
function isStringArray(value) {
    return Array.isArray(value) && value.every((item) => typeof item === "string");
}
function parseTemplate(value, index) {
    if (!value || typeof value !== "object") {
        throw new Error(`lark-cli-verified-templates.json[${index}] must be an object`);
    }
    const row = value;
    if (!isNonEmptyString(row.id)) {
        throw new Error(`lark-cli-verified-templates.json[${index}].id must be a non-empty string`);
    }
    if (!isNonEmptyString(row.intent)) {
        throw new Error(`${row.id}.intent must be a non-empty string`);
    }
    if (!isNonEmptyString(row.domain)) {
        throw new Error(`${row.id}.domain must be a non-empty string`);
    }
    if (!isNonEmptyString(row.command)) {
        throw new Error(`${row.id}.command must be a non-empty string`);
    }
    if (!isStringArray(row.argv) || row.argv.length === 0) {
        throw new Error(`${row.id}.argv must be a non-empty string array`);
    }
    if (typeof row.note !== "string") {
        throw new Error(`${row.id}.note must be a string`);
    }
    if (!isStringArray(row.matchFlags)) {
        throw new Error(`${row.id}.matchFlags must be a string array`);
    }
    if (!isStringArray(row.matchSubcommands)) {
        throw new Error(`${row.id}.matchSubcommands must be a string array`);
    }
    return {
        id: row.id,
        intent: row.intent,
        domain: row.domain,
        command: row.command,
        argv: row.argv,
        note: row.note,
        matchFlags: row.matchFlags,
        matchSubcommands: row.matchSubcommands,
    };
}
function parseTemplates(raw) {
    if (!Array.isArray(raw)) {
        throw new Error("lark-cli-verified-templates.json must be an array");
    }
    const parsed = raw.map((row, index) => parseTemplate(row, index));
    const ids = new Set();
    for (const row of parsed) {
        if (ids.has(row.id)) {
            throw new Error(`duplicate lark-cli verified template id ${row.id}`);
        }
        ids.add(row.id);
    }
    return parsed;
}
export const LARK_CLI_VERIFIED_TEMPLATES = parseTemplates(rawTemplates);
//# sourceMappingURL=lark-cli-verified-templates.js.map